import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">        <Link to="/" className="logo">
          <img src="/logorec.png" alt="Aesthetic AI Receptionist" className="logo-image" />
          <span className="logo-text">Aesthetic <span>AI</span> Receptionist</span>
        </Link>
        
        <nav className="nav-links">
          <a href="#demo">Demo</a>
          <a href="#features">Features</a>
          <a href="#integrations">Integrations</a>
          <a href="#data-protection">Security</a>
          <a href="#about">About</a>
        </nav>
      </div>
    </header>
  );
};

export default Header; 